import dayjs, { Dayjs } from "dayjs";

// The backend stores booking times as a naive LocalDateTime (no timezone). To
// keep the wall-clock time intact end-to-end we must NOT convert to UTC: a 14:00
// slot is sent, stored and read back as 14:00 regardless of the browser's zone.

// Serialize a Dayjs as a naive "YYYY-MM-DDTHH:mm:ss" wall-clock string (no "Z",
// no offset), suitable for a LocalDateTime backend.
export const toLocalDateTime = (date: Dayjs): string =>
  date.format("YYYY-MM-DDTHH:mm:ss");

// Combine a calendar day with a "HH:mm" slot into the naive wall-clock string to
// persist, e.g. (2026-06-22, "14:00") -> "2026-06-22T14:00:00".
export const slotToLocalDateTime = (day: Dayjs, slot: string): string =>
  `${day.format("YYYY-MM-DD")}T${slot}:00`;

// Wall-clock "HH:mm" from a naive LocalDateTime string, with no timezone shift.
export const toBookingHour = (date: string): string => dayjs(date).format("HH:mm");
